import { BackButtonContainer, CampaignImg, CompletedIcon, Content, ContentInner, DivInHeader, Header, HeaderIcon, Navigation, Progress, ProgressContainer, ProgressFull, ProgressWrapper, Title, Wrapper } from "./Accordion.style";
import { MutableRefObject, useEffect, useMemo, useRef, useState } from "react";
import { useWindowResize } from "../../../../hooks/useWindowResize";
import { AccordionRoutesEnum } from "../../../../types/AccordionRoutes";
import { useStore } from "../../../../store/store";
import Button from "../Button";
import { ButtonBackgroundColorType } from "../Button/Button";
import { TrackingFlowTypeEnum } from "../../../../types/TrackingFlowTypeEnum";

export enum AccordionStateEnum {
  Completed = "Completed",
  Active = "Active",
  Inactive = "Inactive",
}

interface Props {
  title: string | undefined;
  step: AccordionRoutesEnum;
  children: React.ReactNode;
  onNext: () => void;
  previousStep?: AccordionRoutesEnum;
  stepComplete: boolean;
  headerImg: string;
  step2?: AccordionRoutesEnum;
}

export default function Accordion({ title, children, step, onNext, previousStep, stepComplete, headerImg, step2 }: Props) {
  const expandedHeight = useRef<number>(0);
  const contentInnerRef = useRef<HTMLDivElement>(null);
  const windowSize = useWindowResize();
  const [height, setHeight] = useState(0);
  const accordionRoute = useStore.useAccordionRoute();
  const accordionRouteCompletedArray = useStore.useAccordionRouteCompletedArray();
  const setAccordionRoute = useStore.useSetAccordionRoute();
  const scrollRef = useRef() as MutableRefObject<HTMLDivElement>;
  const scrollRefBack = useRef() as MutableRefObject<HTMLDivElement>;
  const showTimerPopupOI = useStore.useShowTimerPopupOI();
  const setShowTimerPopupOI = useStore.useSetShowTimerPopupOI();
  const payload = useStore.usePayload();
  const dropdownProductcardClicked = useStore.useDropdownProductcardClicked();
  const setGoBackNav = useStore.useSetGoBackNav();
  const goBackNav = useStore.useGoBackNav();

  const currentState = useMemo(() => {
    if (accordionRoute === step) {
      return AccordionStateEnum.Active;
    } else if (!accordionRouteCompletedArray.includes(step)) {
      return AccordionStateEnum.Inactive;
    } else if (accordionRouteCompletedArray.includes(step)) {
      return AccordionStateEnum.Completed;
    } else {
      return AccordionStateEnum.Inactive;
    }
  }, [accordionRoute, accordionRouteCompletedArray]);

   useEffect(() => {
    if (contentInnerRef.current) {
      if(step === AccordionRoutesEnum.ProductStep) {
        expandedHeight.current = contentInnerRef.current?.getBoundingClientRect().height + 20;
      } else {
        expandedHeight.current = contentInnerRef.current?.getBoundingClientRect().height
      }
    }
  }, [windowSize, payload, dropdownProductcardClicked]);

  useEffect(() => {
    if (currentState === AccordionStateEnum.Active) {
      setHeight(expandedHeight.current);
    } else {
      setHeight(0);
    }
  }, [currentState, expandedHeight, windowSize, payload, dropdownProductcardClicked]);

  const goBack = () => {
    if(previousStep) {
      setAccordionRoute(previousStep, payload, step2 === AccordionRoutesEnum.ProductStepV2 ? TrackingFlowTypeEnum.VerticalV2 : TrackingFlowTypeEnum.Vertical);
      scrollTo({ top: scrollRef.current.offsetTop + 60, behavior: "smooth" })
      // If user goes back, turn off the timer for exit intent popup
      setShowTimerPopupOI(false);
      setGoBackNav(goBackNav + 1);
    }
  };

  const scrollNext = () => {
    if(!showTimerPopupOI) {
      // If user clicks next and the timerOn is set to false, then set timerOn to true
      setShowTimerPopupOI(true);
    }
    onNext()
    scrollTo({ top: scrollRef.current.offsetTop + 60, behavior: "smooth" })
  } 

  return (
    <>
      <Wrapper state={currentState} ref={scrollRefBack}>
        <Header
          state={currentState}
          // onClick={() => {

          //   if (accordionRouteCompletedArray.includes(step)) {
          //     setAccordionRoute(step, payload);
          //     scrollTo({ top: scrollRef.current.offsetTop, behavior: "smooth" })
          //   }
          // }}
        >
          <DivInHeader>
            <HeaderIcon src={headerImg} aria-hidden="true" alt=""></HeaderIcon>
            <Title state={currentState}>{title}</Title>
          </DivInHeader>
          {currentState === AccordionStateEnum.Completed && <CompletedIcon />}
        </Header>
        <Content height={height}>
          <ContentInner ref={contentInnerRef}>
            <div ref={scrollRef}></div>
            {children}
        {/*     <ProgressContainer>
              { step === AccordionRoutesEnum.OccupationStep 
              ? <ProgressFull />
              : <Progress />
              } 
              { step === AccordionRoutesEnum.ProductStep 
              ? <ProgressFull />
              : <Progress />
              } 
              { step === AccordionRoutesEnum.CircumstanceStep 
              ? <ProgressFull />
              : <Progress />
              } 
              { step === AccordionRoutesEnum.InformationStep 
              ? <ProgressFull />
              : <Progress />
              } 
              { step === AccordionRoutesEnum.ConsentStep 
              ? <ProgressFull />
              : <Progress />
              }
              { step === AccordionRoutesEnum.PaymentStep 
              ? <ProgressFull />
              : <Progress />
              }
              </ProgressContainer> */}
            {step !== AccordionRoutesEnum.PaymentStep && (
              <Navigation>
                {step != AccordionRoutesEnum.OccupationStep && (
                  <BackButtonContainer>
                    <Button bgColor={ButtonBackgroundColorType.Transparent} blockButton={false} onClick={goBack}>
                      Tilbage
                    </Button>
                  </BackButtonContainer>
                )}
                <Button bgColor={!stepComplete ? ButtonBackgroundColorType.Grey : ButtonBackgroundColorType.Orange} blockButton={false} onClick={() => { scrollNext(); setGoBackNav(0); }} disabled={!stepComplete}>
                  <b>{step === AccordionRoutesEnum.OccupationStep ? "Se priser" : "Næste"}</b>
                </Button>
              </Navigation>
            )}
            {step === AccordionRoutesEnum.PaymentStep && (
              <Navigation>
                <BackButtonContainer>
                  <Button bgColor={ButtonBackgroundColorType.Transparent} blockButton={false} onClick={goBack}>
                    Tilbage
                  </Button>
                </BackButtonContainer>
                <Button bgColor={!stepComplete ? ButtonBackgroundColorType.Grey : ButtonBackgroundColorType.Orange} blockButton={false} disabled={!stepComplete} onClick={scrollNext}>
                  <b>Meld dig ind</b>
                </Button>
              </Navigation>
            )}
          </ContentInner>
        </Content>
      </Wrapper>
    </>
  );
}
